export enum ProductType {
  Unknown = 'all',
  Dry = 'dry',
  Wet = 'wet',
}
